import Vue from 'vue';

const state = {
  verificationTokens: {}
}

const getters = {
  
  verificationToken (state) {
    return id => {
      if (id in state.verificationTokens) return state.verificationTokens[id];
      else return false;
    }
  },

  verificationTokens (state) {
    return state.verificationTokens;
  }

}

const mutations = {
  storeVerificationTokens (state, tokens) {
    
    tokens.forEach(token => {
      var current = state.verificationTokens[token._id] || {};
      Vue.set(state.verificationTokens, token._id, {
        ...current,
        ...token
      });
    });
  },

  removeVerificationToken (state, token) {
    delete state.verificationTokens[token];
  }
}

const actions = {
  
  loadVerificationToken ({commit}, params) {
    
    if (!params.token) {
      return Promise.reject('state.verification - loading Verification Token - Missing required param "token"');
    }

    return window.server.getReq('verification/' + params.token, {
    
    })
    .then(data => {
      commit('storeVerificationTokens', [data]);
      return Promise.resolve(data);
    })  
    .catch(e => {
      return Promise.reject(e);
    });

  },

  verifyPasswordToken ({commit}, params) {
    
    if (!params.token) {
      return Promise.reject('state.verification - verifyPassword - Missing required param "token"');
    }
    else if (!params.password) {
      return Promise.reject('state.verification - verifyPassword - Missing required param "password"');      
    }

    return window.server.postReq('verification/' + params.token, {
      password: params.password
    })
    .then(data => {
      return Promise.resolve(data);
    })  
    .catch(e => {
      return Promise.reject(e);
    });

  },

  verifyEmailToken ({commit}, params) {
    
    if (!params.token) {
      return Promise.reject('state.verification - verifyPassword - Missing required param "token"');
    }

    return window.server.postReq('verification/' + params.token, {})
    .then(data => {
      return Promise.resolve(data);
    })  
    .catch(e => {
      return Promise.reject(e);
    });

  }
  
};

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/verification.js